function readFileAsDataURL(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function capitalize(str: string) {
  return str.substr(0, 1).toUpperCase() + str.substr(1);
}

function arrayToSentence(array: string[]) {
  return array.map((item, idx) => {
    const join = idx
      ? (idx === array.length - 1 ? ' or ' : ', ')
      : '';
    return `${join}${item}`;
  }).join('');
}

export const utils = {
  readFileAsDataURL,
  capitalize,
  arrayToSentence
}